import { gql } from "@apollo/client";
import Fragments from "./fragments";

export const GET_PARTNERS_FOR_COMPANY_QUERY = gql`
  query getPartnersForCompany($filters: FiltersInput!) {
    getPartnersForCompany(filters: $filters) {
      ...partnerForCompanyData
    }
  }
  ${Fragments.partnerForCompanyData}
`;

export const GET_PARTNERS_FOR_COMPANY_BY_ZOOT_CONDITIONS_QUERY = gql`
  query getPartnersForCompanyByZootConditions($paramValues: [ParamValueInput]!) {
    getPartnersForCompanyByZootConditions(paramValues: $paramValues) {
      ...partnerForCompanyData
    }
  }
  ${Fragments.partnerForCompanyData}
`;

export const GET_PARTNERS_FOR_INDIVIDUAL_QUERY = gql`
  query getPartnersForIndividual($pin: String) {
    getPartnersForIndividual(pin: $pin) {
      id
      partnerId
    }
  }
`;

export const GET_PARTNER_SEARCH_CONDITION_QUERY = gql`
  query getPartnerSearchCondition {
    getPartnerSearchCondition {
      searchCondition
      searchConditionText
      paramValues {
        id
        code
        name
        translatedName
        value
      }
    }
  }
`;

export const GET_CLIENT_NAME_QUERY = gql`
  query getClientName($clientId: Int!) {
    getClientName(clientId: $clientId)
  }
`;

export const GET_QUOTE_PARTNERS = gql`
  query getQuotePartners($quoteId: Int!) {
    getQuotePartners(quoteId: $quoteId) {
      id
      quoteId
      partnerId
      partnerName
      roleId
      roleName
    }
  }
`;

export const GET_ESTIMATION_SELECTED_PARTNER = gql`
  query getEstimationSelectedPartner($quoteId: Int!) {
    getEstimationSelectedPartner(quoteId: $quoteId) {
      ...partnerForCompanyData
    }
  }
  ${Fragments.partnerForCompanyData}
`;

export const CHECK_CONSENT = gql`
  query checkConsent($partnerId: Int!) {
    checkConsent(partnerId: $partnerId)
  }
`;

export const QUOTE_QUERY = gql`
  query quote($quoteId: Int!) {
    quote(quoteId: $quoteId) {
      quoteId
      partnerId
      estimationName
      isEstimation
    }
  }
`;

export const GET_SELECTED_PARTNER_CONTACT_PERSONS = gql`
  query getSelectedPartnerContactPersons($quoteId: Int!) {
    getSelectedPartnerContactPersons(quoteId: $quoteId) {
      webQuoteContactInfoId
      genderId
      firstName
      lastName
      email
      citizenshipId
    }
  }
`;

export const GET_PARTNERS_FOR_SOLE_TRADER_QUERY = gql`
  query getPartnersForSoleTrader(
    $firstName: String
    $lastName: String
    $birthDate: DateTime
    $email: String
    $pin: String
  ) {
    getPartnersForSoleTrader(
      firstName: $firstName
      lastName: $lastName
      birthDate: $birthDate
      email: $email
      pin: $pin
    ) {
      personId
      partnerId
    }
  }
`;

export const GET_CONTACT_PERSONS_FOR_SOLE_TRADER_FEATURE_QUERY = gql`
  query getContactPersonsForSoleTraderFeature($partnerId: Int!) {
    getContactPersonsForSoleTraderFeature(partnerId: $partnerId) {
      genderId
      firstName
      lastName
      email
    }
  }
`;
